module.exports = "/images/vendor/desiigner-svg/svg/google-pay.svg?08eb6d4414beb4e02ccaa779f58c18e2";